module.exports = __webpack_public_path__ + "img/goodreads.2435ca8c.svg";